// Toggle accordion for mobile nav when a parent button is pressed
(() => {
    const panel = document.getElementById('mobile-menu');
    if (!panel) return;
  
    panel.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mobile-submenu-toggle]');
      if (!btn) return;
      e.preventDefault();
  
      const holder = btn.closest('.navPages-item, .navPage-subMenu-item');
      if (!holder) return;

      const targetId = btn.getAttribute('data-collapsible');
      const isBackButton = btn.classList.contains('mobile-back');
      const willOpen = isBackButton ? false : !holder.classList.contains('is-open');
      const primaryToggle = targetId
        ? holder.querySelector(`[data-mobile-submenu-toggle][data-collapsible="${targetId}"]:not(.mobile-back)`)
        : null;

      holder.classList.toggle('is-open', willOpen);

      if (primaryToggle) {
        primaryToggle.setAttribute('aria-expanded', String(willOpen));
      }
  
      // Optional: collapse siblings for single-open behavior
      const siblingScope = holder.parentElement;
      siblingScope.querySelectorAll('.has-subMenu.is-open').forEach(li => {
        if (li !== holder) {
          li.classList.remove('is-open');
          li.querySelectorAll('[data-mobile-submenu-toggle][aria-expanded="true"]').forEach(toggle => {
            if (!toggle.classList.contains('mobile-back')) {
              toggle.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    });
  })();
  
